"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZINDEX = void 0;
var ZINDEX = {
  DRAWER: 'drawer',
  MODAL: 'modal',
  TOOLTIP: 'tooltip',
  OVERLAY: 'overlay',
  NAV: 'nav',
  SUBNAV: 'subnav'
};
exports.ZINDEX = ZINDEX;